<template>
  <div class="box" style="border: 1px solid #bbb">
    <b-loading
      :is-full-page="true"
      :active="isLoading"
      :can-cancel="false"
    ></b-loading>

    <p>
      <b>
        {{ category.name }}
      </b>

      <b-tooltip
        :label="$t('vending.deleteCategory')"
        class="is-pulled-right"
        position="is-left"
        v-if="!vending.vendingInfo.isCacauShow"
      >
        <button class="button is-small" @click="removeVendingCategory">
          <b-icon icon="trash"></b-icon>
        </button>
      </b-tooltip>
    </p>

    <button
      class="button is-small"
      style="margin-top: 0.5rem;"
      @click="showProducts = !showProducts"
    >
      <b-icon v-if="!showProducts" icon="caret-right"></b-icon>
      <b-icon v-if="showProducts" icon="caret-down"></b-icon>
      &nbsp;
      {{
        `${category.products.length} ${$tc(
          "vending.product",
          category.products.length
        )}`
      }}
    </button>

    <b-tooltip
      :label="$t('vending.addProduct')"
      position="is-right"
      style="position: relative; top: 8px; left: 10px;"
      v-if="!vending.vendingInfo.isCacauShow"
    >
      <button class="button is-small" @click="addProductModalVisible = true">
        <b-icon icon="plus-circle" type="is-primary"></b-icon>
      </button>
    </b-tooltip>

    <products-table
      v-show="showProducts && category.products.length > 0"
      :products="category.products"
      :vending="vending"
      :categoryId="category._id"
      @update-vending="$emit('update-vending')"
    />

    <p
      v-show="showProducts && category.products.length === 0"
      style="margin-top: 1rem;"
    >
      {{ $t("vending.categoryHasNoProducts") }}
    </p>

    <b-modal :active.sync="addProductModalVisible">
      <add-product-modal
        :categoryId="category._id"
        :vendingId="vending._id"
        @update-vending="$emit('update-vending')"
      />
    </b-modal>
  </div>
</template>

<script>
import { common } from "../../mixins/common";
import productsTable from "./ProductsTable";
import addProductModal from "./AddProductModal";

export default {
  mixins: [common],

  props: ["category", "vending"],

  components: {
    productsTable,
    addProductModal
  },

  data() {
    return {
      isLoading: false,
      showProducts: false,
      addProductModalVisible: false
    };
  },

  methods: {
    removeVendingCategory() {
      this.$buefy.dialog.confirm({
        title: this.$t("vending.removeCategoryTitle"),
        message: this.$t("vending.removeCategoryMessage"),
        confirmText: this.$t("common.yes"),
        cancelText: this.$t("common.cancel"),
        type: "is-primary",
        onConfirm: () => {
          this.isLoading = true;
          this.$store
            .dispatch("removeVendingCategory", {
              categoryId: this.category._id,
              vendingId: this.vending._id
            })
            .then(res => {
              if (res.data.result === "error") {
                this.alertError(res.data);
              } else {
                this.$buefy.toast.open({
                  message: this.$t("vending.categoryDeleted"),
                  type: "is-success",
                  position: "is-bottom",
                  duration: 3000
                });
                this.$emit("update-vending");
              }
            })
            .catch(err => {
              this.alertError(err);
            })
            .finally(() => {
              this.isLoading = false;
            });
        }
      });
    }
  }
};
</script>
